import React from 'react';
import FormControl from '@mui/material/FormControl';
import InputLabel from '@mui/material/InputLabel';
import Select from '@mui/material/Select';
import MenuItem from '@mui/material/MenuItem';
import { PredefinedDateRange, DateRangeValue } from '../../../types/actionLogsTypes';

interface ActionLogsDateRangeSelectorProps {
  value: DateRangeValue;
  onChange: (value: DateRangeValue) => void;
  predefinedDateRanges: PredefinedDateRange[];
}

const ActionLogsDateRangeSelector: React.FC<ActionLogsDateRangeSelectorProps> = ({
  value,
  onChange,
  predefinedDateRanges,
}) => (
  <FormControl sx={{ minWidth: { xs: '100%', sm: 150 } }} size="small">
    <InputLabel id="range-label">Applied range</InputLabel>
    <Select
      labelId="range-label"
      value={value}
      label="Applied range"
      onChange={(e) => onChange(e.target.value as DateRangeValue)}
    >
      {predefinedDateRanges.map((r) => (
        <MenuItem key={r.value} value={r.value}>
          {r.label}
        </MenuItem>
      ))}
      <MenuItem value="custom">Custom range</MenuItem>
    </Select>
  </FormControl>
);

export default ActionLogsDateRangeSelector;
